import http from '@/services/http'
import { getFeeList } from '../fee'
import * as Types from './types'

/**
 * 订单列表
 * @param data
 * @returns
 */
export const getOrderListApi = async (data) => await http.admin.takeLatest('getOrderListApi', 'post', '/api/sales/order_query/search', data)
/**
 * 订单详情
 * @param orderNo
 * @returns
 */
export const getOrderDetailApi = async (data) => await http.admin.post<Types.ResDetailType>('/api/sales/order_query/get', data)

/**
 * 创单接口
 * @param stepsInfo
 * @returns
 */
export const createOrder = (payload: Types.CreateType) => http.admin.post('/api/sales/order/create', payload)

/**
 * 订单转运单
 * @param payload
 * @returns
 */
export const getLogisticsInfo = (payload: Types.IToLogisticsParams) => http.admin.post<Types.LogisticsOrderInfo>('/api/sales/order/convert_to_logistics_order', payload)

/**
 * 更新运单并发货
 * @param params
 * @returns
 */
export const updateShipOrder = (params: Types.OrderUpdateRequest) => http.noToast.post('/api/order/update', params)

export const getFee = async (payload: Types.FeePayload) => {
  const response = await getFeeList(payload)
  const { data, bizCode, bizMessage, message } = response
  if (bizCode === 'SUCCESS') {
    return data?.shippingFeeResults
  }
  return Promise.reject({ bizCode, bizMessage, message })
}

/**
 * 订单编辑 提交和发货
 * @param params
 * @returns
 */
export const updateOrder = (params: Types.OrderEditRequest) => http.admin.post('/api/sales/order/update', params)

/**
 * 取消发货
 * @param params
 * @returns
 */
export const cancelDelivery = (params: Types.SalesOrderCancelDeliveryRequest) => http.admin.post('/api/sales/order/cancel_delivery', params)

/** 取消关联 */
export const disassociate = (orderNo: string) => http.admin.post('/api/sales/order/unbind', { orderNo })

/**
 * 单个更新订单备注
 * @param params
 * @returns
 */
export const updateRemark = (params: Types.RemarkType) => http.admin.post('/api/sales/order/update_remark', params)

/**
 * 批量更新订单打标接口
 * @param params
 * @returns
 */
export const updateOrderTag = (params: Types.OrderTagParams) => http.admin.post(`/api/sales/order/tag`, params)

/**
 * 下载托运单证明文件，异步，下载中心通知
 * @param data
 * @returns
 */
export const downLoadCertifier = (data: { logisticsNos: string[] }) => http.normal.post('/api/bill/print_delivery_proof', data)
export const batchPrint = (params: Types.PrintType) => http.admin.post<Types.PrintResponse>(`/api/sales/order/print_waybill`, params)
export const invoiceDownloadApi = (orderNos: string[] | string) =>
  http.admin.post(`/api/sales/order/print_receipt`, {
    orderNos: Array.isArray(orderNos) ? orderNos : [orderNos],
  })
